import { Box, Paper, Typography } from "@mui/material";
import muiSytle from "../../../style/components-style/muiStyle";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";

const AdditionalNotes = ({ note }) => {
  const { t } = useTranslation();
  return (
    <Box sx={{ padding: 2, display: "flex", gap: 2, justifyContent: "start" }}>
      <Box>
        <Typography sx={{ fontFamily: "Poppins", fontSize: 14, fontWeight: 400, color: "black", textWrap: "nowrap" }}>{t("Additional Notes")}</Typography>
      </Box>
      <Box>
        <Typography sx={{ fontFamily: "Poppins", fontSize: 14, fontWeight: 100 }}>{note}</Typography>
      </Box>
    </Box>
  );
};
export default AdditionalNotes;
